import React, { FC } from "react";
import clubAvatar from "../../../../assets/clubAvatar.png";
import { ICollectionData } from "../../../../common/interfaces/common.interface";
import "./CollectionData.scss";
const CollectionData: FC<{
  collectionData: ICollectionData;
}> = ({ collectionData }) => {
  return (
    <div className="collection-data">
      <img
        src={collectionData.collectionImageUrl ?? clubAvatar}
        alt="nft_image"
      />
      <div className="collection-data__name-symbol">
        <p className="collection-data__name">{collectionData.name}</p>
        <p className="collection-data__symbol">{collectionData.symbol}</p>
      </div>
    </div>
  );
};

export default CollectionData;
